import axios from "../../../common/config/axios";
import * as types from "./types";

export const getSpareDomainList = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    axios.get('spare_domain/list', { params: data })
    .then((res) => {
        dispatch({
            type: types.SPARE_DOMAIN_LIST,
            payload: res.data
        });
    })
    .catch((err) => {

    });
};

export const createSpareDomain = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    axios.post('spare_domain/create', data)
    .then((res) => {
        dispatch({
            type: types.SPARE_DOMAIN_CREATE,
            payload: res.data
        });
    })
    .catch((err) => {

    });
};

export const deleteSpareDomain = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    axios.post('spare_domain/delete', data)
    .then((res) => {
        dispatch({
            type: types.SPARE_DOMAIN_DELETE,
            payload: res.data
        });
    })
    .catch((err) => {

    });
};